const AdvanceNavIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    className={className}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 13.5412V9.32746C4 7.94901 4.773 6.71415 5.94 6.22706L14.293 2.74338C15.602 2.19885 17 3.26582 17 4.81106V8.51122'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.249 15.9656C17.111 15.9667 17 16.0904 17 16.2428C17 16.3952 17.112 16.5189 17.25 16.5178C17.388 16.5178 17.5 16.3941 17.5 16.2417C17.5 16.0893 17.388 15.9656 17.249 15.9656'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.662 23.5857H18C19.65 23.5857 21 22.0946 21 20.2721V11.8236C21 9.99339 19.657 8.51001 18 8.51001H6C4.895 8.51001 4 9.49856 4 10.7191V13.9288'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.5 24.6903C4.463 24.6903 2 21.9699 2 18.6154C2 15.261 4.463 12.5405 7.5 12.5405C10.538 12.5405 13 15.261 13 18.6154C13 21.9699 10.538 24.6903 7.5 24.6903'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.5 16.1931V21.0387'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.69288 18.6155H5.30688'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default AdvanceNavIcon
